export default __webpack_public_path__ + "static/media/252.574ada18.jpg";